export const each = ( obj, fn ) =>
{
    for( let index in obj )
    {
        if( obj.hasOwnProperty( index ) ) fn( index, obj[index] )
    }
}

export const filter = ( obj, fn ) =>
{
    let newObj = {  }

    for( let index in obj )
    {
        if( obj.hasOwnProperty( index ) )
        {
            if( fn( index, obj[index] ) )
            {
                newObj[ index ] = obj[index]
            }
        }
    }

    return newObj
}

export const mapToArray = ( obj, fn ) =>
{
    let _array = []

    for( let index in obj )
    {
        if( obj.hasOwnProperty( index ) )
        {
            _array.push( fn( index, obj[index] ) )
        }
    }

    return _array
}

export const mapToObject = ( obj, fn ) =>
{
    let _obj = {  }

    for( let index in obj )
    {
        if( obj.hasOwnProperty( index ) )
        {
            const { key, value } = fn( index, obj[index] )

            _obj[ key ] = value
        }
    }

    return _obj
}

export const isObject = obj => ( typeof obj === "object" ) && ( obj !== null )

export const deepFind = (obj, path) => {
    var paths = path.split('.')
        , current = obj
        , i;

    for (i = 0; i < paths.length; ++i) {
        if (current[paths[i]] == undefined) {
            return undefined;
        } else {
            current = current[paths[i]];
        }
    }
    return current;
}

export const getValue = (obj, path, def) => {
    const value = deepFind(obj, path)

    if (value === undefined) {
        return def
    }

    return value
}